import { Popover as GluePopover } from '@tencent/glue-react-ui';
import { withAdpCombine } from '../../config/context/config';
var Content = GluePopover.Content,
  Container = GluePopover.Container,
  ClickTrigger = GluePopover.ClickTrigger,
  ContextMenuTrigger = GluePopover.ContextMenuTrigger,
  FocusTrigger = GluePopover.FocusTrigger,
  HoverTrigger = GluePopover.HoverTrigger,
  ManualTrigger = GluePopover.ManualTrigger;
var AdpPopover = withAdpCombine(GluePopover);
export var Popover = Object.assign(AdpPopover, {
  Content: withAdpCombine(Content),
  Container: withAdpCombine(Container),
  ClickTrigger: withAdpCombine(ClickTrigger),
  ContextMenuTrigger: withAdpCombine(ContextMenuTrigger),
  FocusTrigger: withAdpCombine(FocusTrigger),
  HoverTrigger: withAdpCombine(HoverTrigger),
  ManualTrigger: withAdpCombine(ManualTrigger)
});